<template>
	<div class="card">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19 d-flex justify-content-start">
			            <strong>Pizza</strong>
			        </div>
					<bsh-dropdown-nav
				  		id="financeiroPieNav"
				  		:tabs="tabs"
				  		@navChanged="ChangeChart">
				  	</bsh-dropdown-nav>
				</div>
            </div>
        </div>
        <div class="card-body">
			<chart 
				:key="chartKeyPizza"
				:data="config"
				identify="financeiroChartPie"
				width="100%"
				height="100">
			</chart>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: [],
				datasets: [],
				config: [],
				chartKeyPizza: 1,
				tabs: [
		            {
		              	label: 'Mês',
		              	field: 'mes2'
		            },
		            {
		            	label: 'Ano',
		              	field: 'ano2',
		            },
				],
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/financeiro/chart?data='+this.date)
	            .then(response => {
	            	this.dados = response.data.pie
	            	this.ChangeChart('mes2')
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			setChart(){
				Chart.defaults.global.defaultFontFamily = '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
				Chart.defaults.global.defaultFontColor = '#292b2c';

				var ctx = document.getElementById('financeiroChartPie').getContext('2d');
				var PieChart = new Chart(ctx, this.config);
			},
			ChangeChart(chartPeriod){
				this.datasets = [];
				if(chartPeriod == 'ano2'){
					this.datasets = this.dados.financeiro_ano;
				}
				if(chartPeriod == 'mes2'){
					this.datasets = this.dados.financeiro_mes;
				}
				this.setConfig();
				this.setChart();
				this.chartKeyPizza += 1;
			},
			setLabelAno(){
				return [
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez'
				];
			},
			setLabelMes(){
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				var dia_fim = ultimoDia.getDate();
				var result = [];
				for(var i=1; i<=dia_fim; i++){
					result.push(String(i));
				}	
				return result;
			},
			setConfig(){
				this.config = {
					type: 'pie',
					data: {
						datasets: [{
							data: this.datasets,
							backgroundColor: [
								"rgba(41,155,7,1)",
								"rgba(228,15,15,1)"
							],
							label: 'Valor'
						}],
						labels: [
							'Receita',
							'Despesa'
						]
					},
					options: {
						responsive: true
					}
				};
			}
		}
	}
</script>